import {
	Box,
	Card,
	CheckCircle,
	Icon,
	ListItem,
	Loader,
	Typography,
	WarningRounded,
	WatchLaterRounded,
} from '@bharatpe/bharat-ui';
import PageLayout from '@bharatpe/bharat-ui/web/PageLayout';
import React, { useEffect, useState } from 'react';
import { getURLParameter } from 'utils/nativeSupport';
import QueryIcon from 'assets/icons/Autopay/query.svg';
import UpiPoweredBy from 'components/atoms/UpiPoweredBy';
import './styles.scss';
import { formatDate, formatDateDynamic, isEmpty } from 'utils/Utils';
import { RaiseUpiComplaint, TriggerNativeApiWrapper } from 'utils/nativeUpiHandler';
import { API_URL } from 'Services/CONSTANT';
import Toasty from 'components/atoms/Toasty';
import ReasonCodeModal from 'components/organisms/Modals/ReasonCodeModal';
import AlertModal from '../Modals/AlertModal';
import { GetUdirComplaint, GetUdirReasonCodes } from 'Services';
import history from 'utils/History';
import AppHeader from 'components/atoms/AppHeader';
import './styles.scss';
import { sendEvent } from 'utils/Sentry';
import { logAnalyticsEvent } from 'utils/AnalyticsEvent';
import { UPI_ERROR_CODE } from 'utils/CONSTANT';
import { useLanguageConfig } from 'Slices/LanguageConfigSlice';

const AutoPayPaymentStatus: React.FC = () => {
	const [transactionData, setTransactionData] = useState<any>({});
	const [loading, setLoading] = useState(true);
	const [showComplaintModal, setShowComplaintModal] = useState<boolean>(false);
	const [showAttemptModal, setShowAttemptModal] = useState<boolean>(false);
	const [showErrorModal, setShowErrorModal] = useState<boolean>(false);
	const [reasonCodes, setReasonCodes] = useState<any>([]);
	const [selectedQuery, setSelectedQuery] = useState<any>();
	const [complaint, setComplaint] = useState<any>();
	const { languageData } = useLanguageConfig();

	const {
		amount = '',
		status = '',
		created_at,
		transaction_id,
		payee_details = {},
		payer_details = {},
		remarks = '',
		original_transaction_id = '',
		bank_rrn = '',
	} = (transactionData as any) || {};

	const { vpa = '', name = '' } = payee_details;
	const { bank_logo = '', bank_name = '', account_number = '' } = payer_details;

	useEffect(() => {
		(async () => {
			try {
				const data: any = await TriggerNativeApiWrapper(
					`${API_URL.transaction_details}/${getURLParameter(window.location.href, 'transaction-id')}`,
					'GET',
					{},
					{},
				);
				setLoading(false);
				setTransactionData(data);
			} catch (err: any) {
				sendEvent(err);
				Toasty.error(err?.error || 'something went wrong');
			}
		})();
	}, []);

	const getTransactionStatusClassName = (status: string) => {
		switch (status) {
			case 'SUCCESS':
				return 'success-border';
			case 'FAILED':
				return 'failed-border';
			case 'PENDING':
			case 'INITIATED':
				return 'pending-border';
			case 'CLOSED':
				return 'success-border';
			case 'OPEN':
				return 'primary-border';
		}
	};

	const getTransactionStatusIcon = (status: string) => {
		switch (status) {
			case 'SUCCESS':
				return CheckCircle;
			case 'FAILED':
				return WarningRounded;
			case 'PENDING':
			case 'INITIATED':
				return WatchLaterRounded;
		}
	};

	const getTransactionStatusIconColor = (status: string) => {
		switch (status) {
			case 'SUCCESS':
				return 'success-logo';
			case 'FAILED':
				return 'failed-logo';
			case 'PENDING':
			case 'INITIATED':
				return 'pending-logo';
		}
	};

	const getTransactionStatusFontColor = (status: string) => {
		switch (status) {
			case 'OPEN':
				return 'primary';
			case 'CLOSED':
				return 'success';
		}
	};

	const getTransactionStatus = (status: string) => {
		switch (status) {
			case 'SUCCESS':
				return languageData.TRANSACTION_SUCCESSFUL;
			case 'FAILED':
				return languageData.TRANSACTION_FAILED;
			case 'PENDING':
			case 'INITIATED':
				return languageData.TRANSACTION_PENDING;
		}
		return '';
	};

	const handleRaiseQuery = async () => {
		try {
			const reason = await GetUdirReasonCodes();

			if (reason) {
				const merchantQuery: any = [];
				reason.udir_reason_codes.map((code: any) => {
					if (code.type == 'MERCHANT') {
						merchantQuery.push(code);
					}
				});
				setReasonCodes(merchantQuery);
				setShowComplaintModal(true);
				logAnalyticsEvent({
					trigger_point: 'Modal View',
					Product: 'AutoPayUPI',
					Flow: 'UDIR',
					Screen: 'CMPModal',
					Module: 'Modal',
					Action: 'Viewed',
				});
			}
		} catch (err: any) {
			sendEvent(err);
			console.log(err);
		}
	};

	const handleRegisterComplaint = async () => {
		logAnalyticsEvent({
			trigger_point: 'Clicks on Confirm',
			Product: 'AutoPayUPI',
			Flow: 'UDIR',
			Screen: 'CMPModal',
			Module: 'Modal',
			Element: 'CTA',
			Action: 'Tapped',
			optionID: selectedQuery?.id,
			ctaType: 'Confirm',
		});
		console.log(selectedQuery);
		const payload = {
			reason_code: selectedQuery.reason_code,
			remark: remarks || 'abc',
			oriSeqNo: original_transaction_id,
		};
		try {
			const register = await RaiseUpiComplaint(payload);
			if (register) {
				setComplaint(register);
			}
			setShowComplaintModal(false);
		} catch (err: any) {
			setShowComplaintModal(false);
			if (err?.error?.message === 'Upi complaint already exists') {
				Toasty.error('Upi complaint already exists');
			} else if (UPI_ERROR_CODE.includes(err?.errorCode)) {
				Toasty.error(err?.error);
				sendEvent(err);
			} else {
				Toasty.error('Something went wrong!!');
				sendEvent(err);
			}
		}
	};

	const fetchComplaint = async () => {
		if (transactionData?.upi_complaint_id) {
			try {
				const complaint = await GetUdirComplaint(transactionData?.upi_complaint_id);
				if (complaint) {
					setComplaint(complaint);
				}
			} catch (err: any) {
				Toasty.error('Something went wrong!!');
				sendEvent(err);
			}
		}
	};

	useEffect(() => {
		fetchComplaint();
	}, [transactionData]);

	const openComplaint = () => {
		history.push({
			pathname: '/upi/udir/details',
			state: complaint.upi_complaint_id,
		});
	};

	const handleReasonCodesModalClosePress = () => {
		logAnalyticsEvent({
			trigger_point: 'Clicks on Cancel',
			Product: 'AutoPayUPI',
			Flow: 'UDIR',
			Screen: 'CMPModal',
			Module: 'Modal',
			Element: 'CTA',
			Action: 'Tapped',
			ctaType: 'Cancel',
		});
		setShowComplaintModal(false);
	};
	return loading ? (
		<Loader loading />
	) : (
		<PageLayout className="white-background">
			<AppHeader
				title={''}
				options={status == 'SUCCESS' || status == 'FAILED' ? <img src={QueryIcon} onClick={handleRaiseQuery} /> : null}
			/>
			<>
				<div className="mx5 mt6 payment-status-content">
					<Card className={`p4 mb4 mt5 flex flex-column ${getTransactionStatusClassName(status)}`}>
						<div className="flex flex-row flex-center flex-justify">
							<div className="flex flex-column">
								<Typography variant="Light200" className="text-left ">
									{getTransactionStatus(status)}
								</Typography>
								<Typography variant="Bold700 mt2" className="text-left">
									₹{amount}
								</Typography>
							</div>
							<Icon
								icon={getTransactionStatusIcon(status)}
								className={`${getTransactionStatusIconColor(status)} mr2`}
								height={50}
								width={50}
							/>
						</div>
						<div className="horizontal-divider my4" />
						<div className="flex flex-column flex-start">
							<Typography variant="Light100" className="grey">
								{languageData.PAID_TO}
							</Typography>
							<Typography variant="Regular300 mt1">{name}</Typography>
							<Typography variant="Light100" className="grey">
								{vpa}
							</Typography>
						</div>
						<div className="horizontal-divider my4" />
						<div className="flex flex-column flex-start">
							<Typography variant="Light100" className="grey">
								{languageData.DEBITED_FROM}
							</Typography>
							<div className="flex flex-row flex-center mt2">
								<img src={bank_logo} loading="lazy" className="mr2" width={40} />
								<div className="flex flex-column flex-start">
									<Typography variant="Regular200">{bank_name}</Typography>
									<Typography variant="Light100 mt1">{account_number}</Typography>
								</div>
							</div>
						</div>
						<div className="horizontal-divider my4" />
						<div className="flex flex-column">
							<div className="flex flex-row flex-justify mb4">
								<div className="flex flex-column flex-start">
									<Typography variant="Light100" className="grey">
										{languageData.DATE}
									</Typography>
									<Typography variant="Regular200 mt2">{formatDate(created_at)}</Typography>
								</div>
								<div className="flex flex-column flex-end">
									<Typography variant="Light100" className="grey">
										{languageData.TIME}
									</Typography>
									<Typography variant="Regular300 mt2">{formatDateDynamic(created_at, 'h:mm a')}</Typography>
								</div>
							</div>
							<div className="flex flex-row flex-justify mb4">
								<div className="flex flex-column flex-start">
									<Typography variant="Light100" className="grey">
										{languageData.TRANSACTION_ID}
									</Typography>
									<Typography variant="Regular200 mt2">{transaction_id}</Typography>
								</div>
								<div className="flex flex-column flex-end">
									<Typography variant="Light100" className="grey">
										{languageData.MODE}
									</Typography>
									<Typography variant="Regular200 mt2">{languageData.UPI}</Typography>
								</div>
							</div>
							{!isEmpty(bank_rrn) && (
								<div className="flex flex-row flex-justify">
									<div className="flex flex-column flex-start">
										<Typography variant="Light100" className="grey">
											{languageData.UTR}
										</Typography>
										<Typography variant="Regular200 mt2">{bank_rrn}</Typography>
									</div>
								</div>
							)}
						</div>
						<div className="horizontal-divider my4" />
						<div className="flex flex-column flex-start">
							<Typography variant="Light100" className="grey">
								{languageData.REMARKS}
							</Typography>
							<Typography variant="Regular200 mt2">Loan repayment</Typography>
						</div>
					</Card>
					{complaint && (
						<Card className="flex flex-column mb4" onClick={openComplaint}>
							<Box className="flex flex-row w-100 pt3 pb1 px4">
								<Box className="flex flex-start w-100">
									<Typography className="Light200 mr1 grey-dark"> {languageData.COMPLAINT}: </Typography>
									<Typography className="Regular300"> {complaint?.complaint_ref_no} </Typography>
								</Box>
								<Box
									className={`box-border flex flex-end ml2 secondary-background ${getTransactionStatusClassName(
										complaint?.status,
									)}`}>
									<Typography className={`Regular200 uppercase ${getTransactionStatusFontColor(complaint?.status)}`}>
										{complaint.status}
									</Typography>
								</Box>
							</Box>
							<Box className="horizontal-divider my1" />
							<Box className="flex flex-row">
								<ListItem
									title={complaint.upi_complaints_reason}
									subtitle={`Created: ${formatDateDynamic(complaint.created_at, `DD MMM' YYYY`)}`}
									hideRightArrow={false}
								/>
							</Box>
						</Card>
					)}
					<ReasonCodeModal
						showComplaintModal={showComplaintModal}
						setShowModal={setShowComplaintModal}
						handleModalClose={() => handleReasonCodesModalClosePress()}
						list={reasonCodes}
						setSelectedQuery={setSelectedQuery}
						handleRegisterComplaint={handleRegisterComplaint}
					/>
					<AlertModal
						handleClick={() => setShowAttemptModal(false)}
						title={languageData.CAN_NOT_RAISE_COMPLAINT}
						description={
							languageData.YOU_CAN_RAISE_COMPLAINT_ONLY_AFTER_5_MINUTES_OF_INITIATING_TRANSACTION_PLEASE_TRY_LATER
						}
						buttonName={languageData.UNDERSTOOD}
						icon={''}
						type={''}
						visible={showAttemptModal}
						showCloseButton={false}
					/>
					<AlertModal
						handleClick={() => setShowErrorModal(false)}
						title={languageData.UNABLE_TO_RAISE_COMPLAINT}
						description={languageData.WE_ARE_UNABLE_TO_PROCESS_YOUR_REQUEST_TO_REGISTER_COMPLAINT_DUE_TO_NPCI_ERROR}
						buttonName={languageData.TRY_AGAIN}
						icon={''}
						type={''}
						visible={showErrorModal}
						showCloseButton={false}
					/>
				</div>
				<div className="upi-powered-sticky">
					<UpiPoweredBy />
				</div>
			</>
		</PageLayout>
	);
};
export default AutoPayPaymentStatus;
